import type { AdminViewDefinition } from "../components/admin-components.js";
import { auditOverlayViews } from "./audit/audit-overlays.js";
import { domainOverlayViews } from "./domains/domain-overlays.js";
import { installationOverlayViews } from "./installations/installation-overlays.js";
import { jobOverlayViews } from "./jobs/job-overlays.js";
import { operationOverlayViews } from "./operations/operation-overlays.js";
import { usageOverlayViews } from "./usage/usage-overlays.js";

export const interactionAdminViews: AdminViewDefinition[] = [
  ...installationOverlayViews,
  ...jobOverlayViews,
  ...domainOverlayViews,
  ...operationOverlayViews,
  ...auditOverlayViews,
  ...usageOverlayViews,
];
